import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import Confirmation from "../Modal/Confirmation";
import useInternalNotificationsDelete from "@/shared/mutations/internalNotifications/useInternalNotificationsDelete";

const InternalNotificationDeleteModal = () => {
  const [{ id, callback }] = useModalMeta();
  const destroy = useInternalNotificationsDelete();
  const setModal = useSetModal();

  return (
    <Confirmation
      onSuccess={async () => {
        destroy.mutateAsync(
          { itemId: id },
          {
            onSuccess: () => {
              setModal("", {});
              callback();
            },
          }
        );
      }}
      show
      onExit={() => setModal("")}
      isPending={destroy.isPending}
    />
  );
};

export default InternalNotificationDeleteModal;
